import React, { useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Stack,
  Divider,
  Typography,
} from "@mui/material";
import {
  Terrain,
  Agriculture,
  WaterDrop,
  Warning,
  Landscape,
  Notes,
  VerticalAlignBottom,
  FilterHdr,
  TrendingUp,
  Straighten,
  Opacity,
  Grass,
  NaturePeople,
} from "@mui/icons-material";

// Ortak bileşenleri içe aktarıyoruz
import {
  ModernCardHeader,
  RenderSelect,
  RenderInput,
  RenderMultiSelect,
} from "../components/common/ModernUI";

import {
  FIZYOGRAFYA_OPTIONS,
  ANA_MATERYAL_OPTIONS,
  ARAZI_KULLANIM_KATEGORI_OPTIONS,
  ARAZI_KULLANIM_DETAY_OPTIONS,
  URUN_OPTIONS,
  EGIM_YUZDE_OPTIONS,
  EGIM_YONU_OPTIONS,
  TABII_DRENAJ_OPTIONS,
  SEL_BASMASI_OPTIONS,
  TASKIN_OLASILIGI_OPTIONS,
  EROZYON_SEKLI_OPTIONS,
  SU_EROZYON_DERECESI_OPTIONS,
  INSAN_ETKISI_OPTIONS,
  TASLILIK_OPTIONS,
  CAKILLILIK_OPTIONS,
  KAYALILIK_OPTIONS,
  YUZEY_CATLAK_OPTIONS,
  BTG_OPTIONS,
  RUZGAR_ASINDIRMA_OPTIONS,
  RUZGAR_YIGILMA_OPTIONS,
  YUZEY_TOPOGRAFYASI_OPTIONS,
} from "../constants/fieldConstants";

const FieldCharsTab = ({ formData, setFormData }) => {
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      sel_basmasi: prev.sel_basmasi || "Yok",
      taskin_olasiligi: prev.taskin_olasiligi || "Yok",
      yuzey_catlak: prev.yuzey_catlak || "Yok",
      kayalilik: prev.kayalilik || "Yok",
      cakillilik: prev.cakillilik || "Yok",
      ruzgar_asinma: prev.ruzgar_asinma || "Yok",
      ruzgar_yigilma: prev.ruzgar_yigilma || "Yok",
      taslilik: prev.taslilik || "Taşsız",
      tabii_drenaj: prev.tabii_drenaj || "Drenaja gereksinim yok (İ)",
    }));
  }, [setFormData]);

  const handleChange = (name, value) => {
    let formattedValue = value;
    if (typeof formattedValue === "string")
      formattedValue = formattedValue.toUpperCase();
    setFormData((prev) => ({ ...prev, [name]: formattedValue }));
  };

  const handleAutoChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMultiSelectChange = (name, newValue) => {
    setFormData((prev) => ({ ...prev, [name]: newValue }));
  };

  return (
    <Box
      sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 3 }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: 3,
        }}
      >
        {/* Fizyografya & Ana Materyal */}
        <Card
          elevation={0}
          sx={{ borderRadius: 4, border: "1px solid #eaecf0" }}
        >
          <CardContent sx={{ p: 3 }}>
            <ModernCardHeader
              title="Fizyografya & Ana Materyal"
              iconNode={<Terrain />}
              color="#2e7d32"
            />
            <Stack spacing={2.5}>
              <RenderSelect
                label="Fizyografya"
                name="fizyografya"
                value={formData.fizyografya}
                options={FIZYOGRAFYA_OPTIONS}
                iconNode={<FilterHdr fontSize="small" />}
                onChange={handleAutoChange}
              />
              <RenderSelect
                label="Ana Materyal Niteliği"
                name="ana_materyal"
                value={formData.ana_materyal}
                options={ANA_MATERYAL_OPTIONS}
                iconNode={<Terrain fontSize="small" />}
                onChange={handleAutoChange}
              />
              <RenderSelect
                label="Büyük Toprak Grubu (BTG)"
                name="btg"
                value={formData.btg}
                options={BTG_OPTIONS}
                iconNode={<Landscape fontSize="small" />}
                onChange={handleAutoChange}
              />
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr 1fr" },
                  gap: 2,
                }}
              >
                <RenderInput
                  label="Kaya Tipi"
                  name="kaya_tipi"
                  value={formData.kaya_tipi}
                  onChange={handleChange}
                />
                <RenderInput
                  label="Mikrorölyef"
                  name="mikrorolyef"
                  value={formData.mikrorolyef}
                  onChange={handleChange}
                />
                <RenderSelect
                  label="Yüzey Topoğrafyası"
                  name="yuzey_topografyasi"
                  value={formData.yuzey_topografyasi}
                  options={YUZEY_TOPOGRAFYASI_OPTIONS}
                  onChange={handleAutoChange}
                />
              </Box>
            </Stack>
          </CardContent>
        </Card>

        {/* Arazi Kullanımı & Vejetasyon */}
        <Card
          elevation={0}
          sx={{ borderRadius: 4, border: "1px solid #eaecf0" }}
        >
          <CardContent sx={{ p: 3 }}>
            <ModernCardHeader
              title="Arazi Kullanımı & Vejetasyon"
              iconNode={<Agriculture />}
              color="#ed6c02"
            />
            <Stack spacing={2.5}>
              <RenderSelect
                label="Arazi Kullanım Sınıfı"
                name="arazi_kullanim_sinif"
                value={formData.arazi_kullanim_sinif}
                options={ARAZI_KULLANIM_KATEGORI_OPTIONS}
                iconNode={<Agriculture fontSize="small" />}
                onChange={handleAutoChange}
              />
              <Box
                sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}
              >
                <RenderSelect
                  label="Kullanım Detayı"
                  name="arazi_kullanim_detay"
                  value={formData.arazi_kullanim_detay}
                  options={ARAZI_KULLANIM_DETAY_OPTIONS}
                  onChange={handleAutoChange}
                />
                <RenderSelect
                  label="Mevcut Ürün"
                  name="urun"
                  value={formData.urun}
                  options={URUN_OPTIONS}
                  iconNode={<Grass fontSize="small" />}
                  onChange={handleAutoChange}
                />
              </Box>
              <RenderInput
                label="Diğer Açıklamalar"
                name="arazi_aciklama"
                value={formData.arazi_aciklama}
                onChange={handleChange}
                placeholder="Verim, rotasyon vb."
                multiline
                rows={2}
                iconNode={<Notes fontSize="small" />}
              />
            </Stack>
          </CardContent>
        </Card>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" },
          gap: 3,
        }}
      >
        {/* Toprak Derinliği */}
        <Card
          elevation={0}
          sx={{ borderRadius: 4, border: "1px solid #eaecf0" }}
        >
          <CardContent sx={{ p: 3 }}>
            <ModernCardHeader
              title="Toprak Derinliği"
              iconNode={<VerticalAlignBottom />}
              color="#795548"
            />
            <Stack spacing={2.5}>
              <RenderInput
                label="Tesirli Derinlik"
                name="tesirli_derinlik"
                type="number"
                value={formData.tesirli_derinlik}
                onChange={handleChange}
                suffix="cm"
                iconNode={<Straighten fontSize="small" />}
              />
              <RenderInput
                label="Kök Gel. Elv. Derinlik"
                name="kok_gel_derinlik"
                type="number"
                value={formData.kok_gel_derinlik}
                onChange={handleChange}
                suffix="cm"
              />
              <RenderInput
                label="Kök Engel Faktör"
                name="kok_gel_eng_faktor"
                value={formData.kok_gel_eng_faktor}
                onChange={handleChange}
                placeholder="Örn: Taş, Taban Suyu"
              />
            </Stack>
          </CardContent>
        </Card>

        {/* Eğim ve Drenaj */}
        <Card
          elevation={0}
          sx={{ borderRadius: 4, border: "1px solid #eaecf0" }}
        >
          <CardContent sx={{ p: 3 }}>
            <ModernCardHeader
              title="Eğim ve Drenaj"
              iconNode={<WaterDrop />}
              color="#0288d1"
            />
            <Stack spacing={2.5}>
              <Box
                sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}
              >
                <RenderSelect
                  label="Eğim (%)"
                  name="egim_yuzde"
                  value={formData.egim_yuzde}
                  options={EGIM_YUZDE_OPTIONS}
                  iconNode={<TrendingUp fontSize="small" />}
                  onChange={handleAutoChange}
                />
                <RenderSelect
                  label="Yön (Bakı)"
                  name="egim_yonu"
                  value={formData.egim_yonu}
                  options={EGIM_YONU_OPTIONS}
                  onChange={handleAutoChange}
                />
              </Box>
              <RenderSelect
                label="Tabii Drenaj"
                name="tabii_drenaj"
                value={formData.tabii_drenaj}
                options={TABII_DRENAJ_OPTIONS}
                iconNode={<WaterDrop fontSize="small" />}
                onChange={handleAutoChange}
              />

              <Box
                sx={{
                  p: 1.5,
                  bgcolor: "#e3f2fd",
                  borderRadius: "8px",
                  border: "1px dashed #90caf9",
                }}
              >
                <Typography
                  variant="caption"
                  fontWeight="bold"
                  color="primary"
                  sx={{ mb: 1, display: "block" }}
                >
                  TABAN SUYU (cm)
                </Typography>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 2,
                  }}
                >
                  <RenderInput
                    label="Min"
                    name="taban_suyu_min"
                    type="number"
                    value={formData.taban_suyu_min}
                    onChange={handleChange}
                  />
                  <RenderInput
                    label="Max"
                    name="taban_suyu_max"
                    type="number"
                    value={formData.taban_suyu_max}
                    onChange={handleChange}
                  />
                </Box>
              </Box>
            </Stack>
          </CardContent>
        </Card>

        {/* Taşkın ve Riskler */}
        <Card
          elevation={0}
          sx={{ borderRadius: 4, border: "1px solid #eaecf0" }}
        >
          <CardContent sx={{ p: 3 }}>
            <ModernCardHeader
              title="Taşkın ve Riskler"
              iconNode={<Warning />}
              color="#d32f2f"
            />
            <Stack spacing={2.5}>
              <RenderSelect
                label="Sel Basması"
                name="sel_basmasi"
                value={formData.sel_basmasi}
                options={SEL_BASMASI_OPTIONS}
                iconNode={<Opacity fontSize="small" />}
                onChange={handleAutoChange}
              />
              <RenderSelect
                label="Taşkın Olasılığı"
                name="taskin_olasiligi"
                value={formData.taskin_olasiligi}
                options={TASKIN_OLASILIGI_OPTIONS}
                iconNode={<Warning fontSize="small" />}
                onChange={handleAutoChange}
              />
              <RenderInput
                label="Taban Suyu Belirtileri"
                name="taban_suyu_belirti"
                value={formData.taban_suyu_belirti}
                onChange={handleChange}
                multiline
                rows={2}
                placeholder="Pas lekesi, gleyleşme..."
              />
            </Stack>
          </CardContent>
        </Card>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1.5fr 1fr" },
          gap: 3,
        }}
      >
        {/* Erozyon ve İnsan Etkisi */}
        <Card
          elevation={0}
          sx={{ borderRadius: 4, border: "1px solid #eaecf0" }}
        >
          <CardContent sx={{ p: 3 }}>
            <ModernCardHeader
              title="Erozyon ve İnsan Etkisi"
              iconNode={<NaturePeople />}
              color="#d32f2f"
            />
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                gap: 3,
              }}
            >
              <Stack spacing={2}>
                <Typography
                  variant="caption"
                  fontWeight="bold"
                  color="text.secondary"
                >
                  EROZYON TÜRÜ & DERECESİ
                </Typography>
                <RenderMultiSelect
                  label="Erozyon Şekli"
                  name="erozyon_sekli"
                  value={formData.erozyon_sekli}
                  options={EROZYON_SEKLI_OPTIONS}
                  onChange={handleMultiSelectChange}
                />
                <RenderSelect
                  label="Su Erozyonu Derecesi"
                  name="su_erozyon_derecesi"
                  value={formData.su_erozyon_derecesi}
                  options={SU_EROZYON_DERECESI_OPTIONS}
                  onChange={handleAutoChange}
                />

                <Box
                  sx={{
                    p: 1.5,
                    bgcolor: "#fff3e0",
                    borderRadius: "8px",
                    border: "1px dashed #ffb74d",
                  }}
                >
                  <Typography
                    variant="caption"
                    fontWeight="bold"
                    color="warning.dark"
                    sx={{ mb: 1, display: "block" }}
                  >
                    RÜZGAR EROZYONU
                  </Typography>
                  <Stack spacing={2}>
                    <RenderSelect
                      label="Aşındırma"
                      name="ruzgar_asinma"
                      value={formData.ruzgar_asinma}
                      options={RUZGAR_ASINDIRMA_OPTIONS}
                      onChange={handleAutoChange}
                    />
                    <RenderSelect
                      label="Yığılma"
                      name="ruzgar_yigilma"
                      value={formData.ruzgar_yigilma}
                      options={RUZGAR_YIGILMA_OPTIONS}
                      onChange={handleAutoChange}
                    />
                  </Stack>
                </Box>
              </Stack>
              <Stack spacing={2}>
                <Typography
                  variant="caption"
                  fontWeight="bold"
                  color="text.secondary"
                >
                  İNSAN ETKİLERİ
                </Typography>
                <RenderMultiSelect
                  label="İnsan Etkileri"
                  name="insan_etkisi"
                  value={formData.insan_etkisi}
                  options={INSAN_ETKISI_OPTIONS}
                  onChange={handleMultiSelectChange}
                />
              </Stack>
            </Box>
          </CardContent>
        </Card>

        {/* Yüzey Özellikleri */}
        <Card
          elevation={0}
          sx={{ borderRadius: 4, border: "1px solid #eaecf0" }}
        >
          <CardContent sx={{ p: 3 }}>
            <ModernCardHeader
              title="Yüzey Özellikleri"
              iconNode={<Landscape />}
              color="#455a64"
            />
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 2,
                mb: 3,
              }}
            >
              <RenderSelect
                label="Taşlılık"
                name="taslilik"
                value={formData.taslilik}
                options={TASLILIK_OPTIONS}
                onChange={handleAutoChange}
              />
              <RenderSelect
                label="Çakıllık"
                name="cakillilik"
                value={formData.cakillilik}
                options={CAKILLILIK_OPTIONS}
                onChange={handleAutoChange}
              />
              <RenderSelect
                label="Kayalılık"
                name="kayalilik"
                value={formData.kayalilik}
                options={KAYALILIK_OPTIONS}
                onChange={handleAutoChange}
              />
              <RenderSelect
                label="Yüzey Çatlakları"
                name="yuzey_catlak"
                value={formData.yuzey_catlak}
                options={YUZEY_CATLAK_OPTIONS}
                onChange={handleAutoChange}
              />
            </Box>
            <Divider sx={{ my: 2 }} />
            <ModernCardHeader
              title="Genel Notlar"
              iconNode={<Notes />}
              color="#607d8b"
            />
            <RenderInput
              name="dusunceler"
              value={formData.dusunceler}
              onChange={handleChange}
              multiline
              rows={4}
              placeholder="Genel değerlendirme ve gözlemler..."
            />
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default React.memo(FieldCharsTab);
